export default __webpack_public_path__ + "static/media/028-matches.2ae1673b.png";